// extracted by mini-css-extract-plugin
module.exports = {"CookieConsentModalContainer":"CookieConsent_CookieConsentModalContainer__Sp4tW","CookieConsentModal":"CookieConsent_CookieConsentModal__6dakL"};